// extracted by mini-css-extract-plugin
export var quillEditor = "_n3-1";
export var variable = "_n3-0";